import {svgIconWrapper} from '../svg-icon-wrapper';

import ShareArrowRegular from './share-arrow-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ShareArrowRegular {...validProps} />;
}

SvgComponent.iconName = 'shareArrowRegular';

export const ShareArrowRegularIcon = svgIconWrapper(SvgComponent);
